// extracted by mini-css-extract-plugin
export default {"container":"DialogError_container__nb0L9","icon":"DialogError_icon__AxsRS"};